// extracted by mini-css-extract-plugin
export default {"container":"GenericBody_container__ZogLj"};